/* eslint-disable no-nested-ternary */
import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { BY_FAMILY, BY_PATIENT, DIAGNOSIS_AWARENESS, EMOTIONAL_COND, PHYSICAL_COND, PROGNOSIS_AWARENESS } from '../constants';

var _ref = /*#__PURE__*/React.createElement(Text, null);

export const PatientCondition = ({
  condition,
  dnr
}) => {
  const diagnoses = condition.diagnoses && condition.diagnoses.diagnosis;
  const physical = condition[PHYSICAL_COND];
  const emotional = condition[EMOTIONAL_COND];
  const progAwareness = condition[PROGNOSIS_AWARENESS];
  const diagAwareness = condition[DIAGNOSIS_AWARENESS];
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width100, styles.borderBottomBlack]
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.printerHeaderText
  }, `${defaults.patientCondition}:`), /*#__PURE__*/React.createElement(PhysicalEmotional, {
    physical: physical,
    emotional: emotional
  }), /*#__PURE__*/React.createElement(View, {
    style: [styles.row, styles.alignItemsCenter]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.width50
  }, diagnoses ? /*#__PURE__*/React.createElement(Diagnoses, {
    diagnoses: diagnoses
  }) : _ref), /*#__PURE__*/React.createElement(View, {
    style: [styles.width50, styles.textAlignCenter, styles.row]
  }, /*#__PURE__*/React.createElement(DiagnosisAwareness, {
    awareness: diagAwareness
  }), /*#__PURE__*/React.createElement(PrognosisAwareness, {
    awareness: progAwareness,
    dnr: dnr
  }))));
};

var _ref2 = /*#__PURE__*/React.createElement(View, null);

var _ref3 = /*#__PURE__*/React.createElement(View, null);

export const PhysicalEmotional = ({
  physical,
  emotional
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.row, styles.width50]
}, physical ? /*#__PURE__*/React.createElement(View, {
  style: styles.width50
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, "Physical Condition:"), /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetText
}, physical)) : _ref2, emotional ? /*#__PURE__*/React.createElement(View, {
  style: [styles.paddingLeftPointTwoCm, styles.width50]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, "Emotional Condition:"), /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetText
}, emotional)) : _ref3);
export const Diagnoses = ({
  diagnoses,
  additional
}) => {
  const diagList = Array.isArray(diagnoses) && (additional ? diagnoses.slice(4) : diagnoses.slice(0, 4));
  return /*#__PURE__*/React.createElement(View, {
    style: styles.width100
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetHeaderField, styles.pYPointOneCm]
  }, `${defaults.patientDiagnoses}:`), diagList ? diagList.map(diagnosis => /*#__PURE__*/React.createElement(Diagnosis, {
    diagnosis: diagnosis,
    key: diagnosis.icd9
  })) : /*#__PURE__*/React.createElement(Diagnosis, {
    diagnosis: diagnoses
  }));
};

const Diagnosis = ({
  diagnosis
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.row, styles.justifyContentBetween]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm, styles.width75]
}, diagnosis.description), /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm, styles.width25, styles.paddingLeftPointTwoCm]
}, diagnosis.icd9));

const subheaderStyle = [styles.FacesheetText, styles.pYPointOneCm, styles.fontFamilyItalic];

const Awareness = ({
  awareness
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, `${defaults.byPatient}: ${awareness[BY_PATIENT]}`), /*#__PURE__*/React.createElement(Text, {
  style: [styles.FacesheetText, styles.pYPointOneCm]
}, `${defaults.byFamily}: ${awareness[BY_FAMILY]}`));

export const DiagnosisAwareness = ({
  awareness
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width50
}, /*#__PURE__*/React.createElement(Text, {
  style: subheaderStyle
}, `${defaults.diagnosisAwareness}`), /*#__PURE__*/React.createElement(Awareness, {
  awareness: awareness
}), /*#__PURE__*/React.createElement(Text, {
  style: subheaderStyle
}, `*${defaults.additionalDiagnosisBelow}`));
export const PrognosisAwareness = ({
  awareness,
  dnr
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width50
}, /*#__PURE__*/React.createElement(Text, {
  style: subheaderStyle
}, `${defaults.prognosisAwareness}`), /*#__PURE__*/React.createElement(Awareness, {
  awareness: awareness
}), /*#__PURE__*/React.createElement(Text, {
  style: subheaderStyle
}, /*#__PURE__*/React.createElement(View, {
  style: styles.row
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.dnr}: `), /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetText
}, dnr))));

var _ref4 = /*#__PURE__*/React.createElement(View, null);

export const AdditionalDiagnoses = ({
  diagnoses
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, `${defaults.additionalDiagnoses}`), diagnoses ? /*#__PURE__*/React.createElement(Diagnoses, {
  diagnoses: diagnoses,
  additional: true
}) : _ref4);